export default __webpack_public_path__ + "static/media/DatumImg.a77cf747.jpg";